var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Form',{attrs:{"fields":_vm.fields,"showErrors":_vm.showErrors,"data":_vm.value,"serverErrors":_vm.serverErrors,"disabled":_vm.disabled},on:{"input":_vm.onChange,"valid":function (valid) { return _vm.$emit('valid', valid); }}})}
var staticRenderFns = []

export { render, staticRenderFns }